export default __webpack_public_path__ + "static/media/Pro-1a.2c9531bf.png";